


<div id="js_video_wrapper" class="bg-gradient video-box border border-dark overflow-hidden p-4 rounded-3 video-wrapper" #video_box>
    <div class="close-video">
        <i id="js_video_close" class="fa-times fas text-white close-sign" (click)="closeVideo(video_box)"></i>
    </div>
    <iframe class="border border-dark overflow-hidden rounded-3 shadow" src="https://www.youtube.com/embed/4B91_uIN8w8?autoplay=1&controls=0&rel=0" allowfullscreen width="100%" height="250px"></iframe>
</div>